export const QuoteSection = () => (
  <section data-testid="quote-section" className="bg-white">
    {/* Desktop — exact 1440px PDF canvas (page y 1698–2128) */}
    <div className="canvas-1440 relative hidden h-[430px] lg:block">
      <img
        src="/assets/carnival.jpg"
        alt="Zan-o-Land carnival at its peak, c. 1922 — historic midway photograph"
        data-testid="carnival-photo"
        loading="lazy"
        className="absolute left-[316px] top-[68px] w-[426px]"
      />
      <p className="absolute left-[320px] top-[375px] text-[11.5px] uppercase tracking-[0.06em] text-[#6B655A]">
        Zan-o-Land Carnival at Its Peak, c. 1922
      </p>
      <img
        src="/assets/poem.png"
        alt="In a Wonderland they lie, Dreaming as the days go by, Dreaming as the summers die: Ever drifting down the stream — Lingering in the golden gleam — Life, what is it but a dream?"
        data-testid="carroll-quote"
        loading="lazy"
        className="absolute left-[780px] top-[70px] w-[318px]"
      />
      <p className="absolute left-[900px] top-[346px] text-[12px] uppercase tracking-[0.08em] text-[#55504A]">
        – Lewis Carroll,
      </p>
      <p className="absolute left-[900px] top-[362px] text-[12px] italic text-[#55504A]">
        Through the Looking-Glass
      </p>
    </div>

    {/* Mobile / tablet — stacked */}
    <div className="px-6 py-10 sm:px-8 lg:hidden">
      <img
        src="/assets/carnival.jpg"
        alt="Zan-o-Land carnival at its peak, c. 1922 — historic midway photograph"
        loading="lazy"
        className="w-full max-w-[430px]"
      />
      <p className="mt-3 text-[10px] uppercase tracking-[0.15em] text-[#6B655A]">
        Zan-o-Land Carnival at Its Peak, c. 1922
      </p>
      <img
        src="/assets/poem.png"
        alt="In a Wonderland they lie — Life, what is it but a dream?"
        loading="lazy"
        className="mt-8 w-[min(100%,300px)]"
      />
      <p className="mt-4 text-[11px] uppercase tracking-[0.08em] text-[#55504A]">– Lewis Carroll,</p>
      <p className="text-[11px] italic text-[#55504A]">Through the Looking-Glass</p>
    </div>
  </section>
);
